module.exports = __webpack_public_path__ + "static/ND-4e2947c05e69fd310bca917a0b54c865.svg";